import {
  ACCOUNTING_BRIDGE_HELP_PAGE_PATH,
  ACCOUNTING_BUDGET_HELP_PAGE_PATH,
  ACCOUNTING_BUDGET_PAGE_PATH,
  ACCOUNTING_MOVEMENT_HELP_PAGE_PATH,
  ACCOUNTING_MOVEMENTS_PAGE_PATH,
  ACCOUNTING_SEPA_HELP_PAGE_PATH,
  ACCOUNTING_SEPA_REMITTANCES_PAGE_PATH,
  ACCOUNTING_SETTINGS_BANK_ACCOUNTS_PATH,
  ACCOUNTING_SETTINGS_BRIDGE_PATH,
  ACCOUNTING_SETTINGS_FISCAL_YEAR_PATH,
  ACCOUNTING_SETTINGS_HELP_PAGE_PATH,
  ACCOUNTING_SETTLEMENTS_HELP_PAGE_PATH,
  ACCOUNTING_SETTLEMENTS_PAGE_PATH,
  REFUND_REQUESTS_PAGE_PATH,
  REFUNDS_CONFIGURATION_PATH,
  REFUNDS_HELP_PAGE_PATH,
  YEATI_LOC_CATALOGUE_PATH,
  YEATI_LOC_COLLECTIONS_PATH,
  YEATI_LOC_HELP_PAGE_PATH,
} from "@/shared/configs/routes.config";

type HelpPageLink = {
  /** Pages de la Console où le bouton d'aide apparaît. */
  routes: string[]
  path: string
  label: string
};

export const HELP_PAGE_LINKS: HelpPageLink[] = [
  {
    // Sur la page des mouvements, l'accès au guide est à côté de « Préparer une remise SEPA ».
    routes: [ACCOUNTING_SEPA_REMITTANCES_PAGE_PATH],
    path: ACCOUNTING_SEPA_HELP_PAGE_PATH,
    label: "Guide des remises SEPA",
  },
  {
    routes: [ACCOUNTING_BUDGET_PAGE_PATH],
    path: ACCOUNTING_BUDGET_HELP_PAGE_PATH,
    label: "Guide des budgets",
  },
  {
    routes: [ACCOUNTING_SETTINGS_FISCAL_YEAR_PATH, ACCOUNTING_SETTINGS_BANK_ACCOUNTS_PATH],
    path: ACCOUNTING_SETTINGS_HELP_PAGE_PATH,
    label: "Guide des paramètres comptables",
  },
  {
    routes: [ACCOUNTING_SETTINGS_BRIDGE_PATH],
    path: ACCOUNTING_BRIDGE_HELP_PAGE_PATH,
    label: "Guide de la synchronisation bancaire",
  },
  {
    // Le guide SEPA garde son accès dans les options avancées de cette même page.
    routes: [ACCOUNTING_MOVEMENTS_PAGE_PATH],
    path: ACCOUNTING_MOVEMENT_HELP_PAGE_PATH,
    label: "Guide : créer et justifier un mouvement bancaire",
  },
  {
    routes: [ACCOUNTING_SETTLEMENTS_PAGE_PATH],
    path: ACCOUNTING_SETTLEMENTS_HELP_PAGE_PATH,
    label: "Guide des remises bancaires",
  },
  {
    routes: [REFUND_REQUESTS_PAGE_PATH, REFUNDS_CONFIGURATION_PATH],
    path: REFUNDS_HELP_PAGE_PATH,
    label: "Guide des remboursements",
  },
  {
    routes: [YEATI_LOC_CATALOGUE_PATH, YEATI_LOC_COLLECTIONS_PATH],
    path: YEATI_LOC_HELP_PAGE_PATH,
    label: "Guide du paramétrage des locations",
  },
];

export const findHelpPageLink = (pathname: string): HelpPageLink | undefined =>
  HELP_PAGE_LINKS.find((link) => link.routes.includes(pathname));
